import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faq";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs font-medium tracking-widest text-accent-600">FAQ</span>
            <h2 className="mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              第一次来瓜田社区，最常被问到的几个问题都在这里。如果还有疑问，欢迎在讨论版直接发帖提问。
            </p>
            <Link
              to="/topics"
              className="mt-5 inline-flex h-10 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-question-answer-line" />
              去讨论版提问
            </Link>
          </div>

          <div className="lg:col-span-8">
            <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              {faqs.map((faq, index) => {
                const open = openIndex === index;
                return (
                  <div key={faq.q}>
                    <h3>
                      <button
                        type="button"
                        aria-expanded={open}
                        onClick={() => setOpenIndex(open ? -1 : index)}
                        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
                      >
                        <span className="flex items-start gap-2.5 text-sm font-medium text-foreground-950">
                          <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded bg-primary-100 text-[11px] font-semibold text-primary-700">
                            Q
                          </span>
                          {faq.q}
                        </span>
                        <i
                          className={`shrink-0 text-lg text-foreground-400 transition-transform ${
                            open ? "rotate-180" : ""
                          }`}
                        >
                          {open ? "ri-subtract-line" : "ri-add-line"}
                        </i>
                      </button>
                    </h3>
                    {open && (
                      <div className="px-5 pb-5 pl-[3.1rem] text-sm leading-relaxed text-foreground-600">
                        {faq.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}